import Vue from 'vue';
import $ from 'jquery';
import Project from 'src/api/project';
import FormatUtils from 'src/utils/formatters';
import Utils from 'src/utils/general';
function processStopwords(rawStopwords) {
    return rawStopwords.split('\n')
        .filter((stopword) => stopword.length > 0)
        .map((stopword) => stopword.trim());
}
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    props: {
        initialStopwords: { type: Array, default: null }
    },
    data() {
        return {
            notification: null,
            showNotification: false,
            stopwordList: [],
            STOPWORDS: {}
        };
    },
    computed: {
        languages() {
            if (this.STOPWORDS) {
                return Object.keys(this.STOPWORDS).sort();
            }
            return [];
        }
    },
    watch: {
        stopwordList(stopwords) {
            this.$emit('stopwordsUpdated', stopwords);
        }
    },
    mounted() {
        Project.getStopwordLists().then((response) => {
            this.STOPWORDS = response;
            if (this.initialStopwords !== null) {
                this.stopwordList = this.initialStopwords.slice().map((stopword) => stopword.trim());
                this.clearLanguage();
            }
            else {
                this.stopwordList = this.STOPWORDS['english'].slice().map((stopword) => stopword.trim());
            }
            this.$nextTick(() => {
                // Initialise language select
                $('.ui.dropdown.language')
                    .dropdown({
                    'action': 'hide',
                    'onChange': this.selectLanguage
                });
            });
        });
    },
    methods: {
        capitalize: FormatUtils.capitalize,
        doUpload(e) {
            this.$validator.validateAll().then(() => {
                let file = e.target.files[0];
                let reader = new window.FileReader();
                reader.onload = (readEvent) => {
                    let stopwords = processStopwords(readEvent.target.result);
                    this.addStopwords(stopwords);
                    e.target.value = null;
                    this.clearLanguage();
                };
                reader.readAsText(file);
            }).catch(() => { });
        },
        addStopword() {
            let stopwordInput = document.getElementById('add-stopword');
            let stopword = stopwordInput.value;
            if (stopword.length === 0) {
                return;
            }
            if (this.stopwordList.indexOf(stopword) < 0) {
                this.stopwordList.splice(0, 0, stopword);
                stopwordInput.value = '';
                this.notify(`${stopword} added`);
            }
            else {
                this.notify(`"${stopword}" already in stopword list`);
            }
        },
        clearStopwords() {
            let c = this.stopwordList.length;
            this.stopwordList.splice(0, c);
            this.notify(`${c} stopwords removed`);
            this.clearLanguage();
        },
        removeStopword(stopword) {
            this.stopwordList.splice(this.stopwordList.indexOf(stopword), 1);
            this.notify(`${stopword} removed`);
        },
        selectLanguage(language) {
            if (language && language.length > 0) {
                // Annoying if required as semantic ui invokes onChange
                // handler when clearing the dropdown.
                this.addStopwords(this.STOPWORDS[language].slice());
            }
        },
        clearLanguage() {
            $('.ui.dropdown.language').dropdown('clear');
        },
        addStopwords(newStopwords) {
            let c = 0;
            for (let sw of newStopwords) {
                if (this.stopwordList.indexOf(sw) < 0) {
                    this.stopwordList.push(sw);
                    c++;
                }
            }
            this.notify(`${c} stopwords added`);
        },
        notify(msg, hideDelay = 3000) {
            if (this.notifyTimer) {
                clearTimeout(this.notifyTimer);
            }
            this.notification = msg;
            this.showNotification = true;
            this.notifyTimer = setTimeout(() => {
                this.showNotification = false;
            }, hideDelay);
        },
        downloadStopwords() {
            Utils.downloadTxt(this.stopwordList.join('\n'), 'stopwords');
        }
    }
});
